import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import planBanner from "../Images/Plans Banner1.png";
import "./PlansV1C.css";

function Plans() {
  const plans = [
    {
      title: "Nutrition Program",
      path: "/plans/nutritionprogram",
      description: "Customized nutrition programs for your health goals.",
    },
    {
      title: "Online Consultation",
      path: "/plans/consultation",
      description: "One-on-one expert nutrition guidance online.",
    },
    {
      title: "Diet Plan",
      path: "/plans/dietplan",
      description: "Personalized diet plans based on your lifestyle.",
    },
    {
      title: "PMOS / PCOD Warriors",
      path: "/plans/pcod",
      description: "Specialized nutrition support for hormonal balance.",
    },
    {
      title: "Bride2Be Nutrition Program",
      path: "/plans/bride2be",
      description: "Bride2Be Nutrition Program for a healthy and glowing wedding journey.",
    },
  ];

  return (
    <div>
        <Image src={planBanner} alt="Nutrinest Plans" className="contact-banner" />
        <section className="plans-page">
      <Container>
        
        {/* <div className="plans-header">
          <h1>Our Plans</h1>
          <p>Choose the right wellness plan for your journey.</p>
        </div> */}

        <div className="plans-circle my-2">

          <div className="plans-header plans-center">
          <h1>Our Plans</h1>
          <p>Choose the right wellness plan for your journey.</p>
        </div>

  {/* <div className="plans-center">
    <span>NutriNest</span>
    <small>Wellness Plans</small>
  </div> */}

  {plans.map((plan, index) => (
    <div className={`plan-orbit plan-${index + 1}`} key={index}>
      <div className="plan-card">

        <h3>{plan.title}</h3>

        <p>{plan.description}</p>

        <Button
          as={Link}
          to={plan.path}
          className="plan-btn"
        >
          Explore
        </Button>

      </div>
    </div>
  ))}

</div>

        
      </Container>
    </section>
    </div>
  );
}

export default Plans;